import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { num, shortDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Factory, Loader2, AlertTriangle } from "lucide-react";

const Stat = ({ label, value, warn, testid }) => (
  <div>
    <p className={`font-display text-xl font-bold ${warn ? "text-rose-400" : ""}`} data-testid={testid}>{value}</p>
    <p className="text-[11px] text-muted-foreground">{label}</p>
  </div>
);

const LabCard = ({ l, i }) => (
  <Card className="p-5" data-testid={`lab-card-${i}`}>
    <div className="flex items-center justify-between">
      <p className="flex items-center gap-2 font-medium"><Factory className="h-4 w-4 text-muted-foreground" />{l.lab}</p>
      {l.late > 0 && <Badge variant="outline" className="border-rose-500/20 bg-rose-500/10 text-rose-400"><AlertTriangle className="mr-1 h-3 w-3" />{l.late} in ritardo</Badge>}
    </div>
    <div className="mt-4 grid grid-cols-4 gap-3">
      <Stat label="Lotti in lavorazione" value={l.active.length} testid={`lab-active-${i}`} />
      <Stat label="Pezzi in lavorazione" value={num(l.pieces_active)} />
      <Stat label="Tempo medio" value={l.avg_days != null ? `${num(l.avg_days)} gg` : "-"} testid={`lab-avg-${i}`} />
      <Stat label="Puntualità" value={l.on_time_rate != null ? `${l.on_time_rate}%` : "-"} warn={l.on_time_rate != null && l.on_time_rate < 70} />
    </div>
    {l.active.length > 0 && (
      <div className="mt-4 space-y-1.5 border-t border-border/60 pt-3">
        {l.active.map((b) => (
          <div key={b.id} className="flex items-center justify-between text-xs">
            <span className="truncate">{b.batch_number} · {b.product_name}{b.color ? ` · ${b.color}` : ""} · {num(b.quantity)} pz</span>
            <span className={`shrink-0 pl-2 ${b.late ? "font-medium text-rose-400" : "text-muted-foreground"}`}>
              {b.expected_delivery ? `consegna ${shortDate(b.expected_delivery)}` : "consegna n.d."}
            </span>
          </div>
        ))}
      </div>
    )}
    <p className="mt-3 text-[11px] text-muted-foreground">{l.delivered} lotti consegnati · {l.total_batches} lotti totali</p>
  </Card>
);

export const LabsSummary = () => {
  const { data = [], isLoading } = useQuery({ queryKey: ["production", "labs-summary"], queryFn: async () => (await api.get("/production/labs/summary")).data });
  if (isLoading) return <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  if (!data.length) return <Card className="p-10 text-center text-sm text-muted-foreground" data-testid="labs-empty">Nessun laboratorio ancora. Indica il laboratorio esterno sui lotti in Confezione per vederne il riepilogo.</Card>;
  return <div className="grid grid-cols-1 gap-4 lg:grid-cols-2" data-testid="labs-summary">{data.map((l, i) => <LabCard key={l.lab} l={l} i={i} />)}</div>;
};
